import { CompactUser } from "../../../../core/CompactModels"
import DataItem from "../../../../models/DataItem"
import DateItem from "../../../../models/DateItem"
import { HereGeocodeAddress, HereGeocodeItem, HereGeocodePosition } from "../../../../models/MapModels"
import PhoneItem from "../../../../models/PhoneItem"
import JobCall from "./JobCall"
import JobPaymentDetails from "./JobPaymentDetails"
import JobPaymentModel from "./JobPaymentModel"

export default interface Job {
    id?: string
    jobId?: string
    contactId?: string
    phone?: PhoneItem
    phoneRaw?: string
    fullName?: string
    countryId?: string
    stateId?: string
    address?: HereGeocodeItem
    timezone?: string
    timezoneOffset?: number
    phoneContact?: PhoneItem
    company?: string
    emailAddress?: string
    jobSourceId?: string
    jobSource?: string
    jobSourceType?: string
    jobStatusId?: string
    jobStatus?: DataItem
    jobTypeId?: string
    jobType?: string
    jobTypeWithGroup?: string
    jobTypeGroupId?: string
    jobTypeGroup?: string
    metroId?: string
    metroName?: string
    techId?: string
    tech?: CompactUser
    techPosition?: HereGeocodePosition
    jobDetails?: string
    flagIds?: string[]
    tagIds?: string[]
    flags?: DataItem[]
    tags?: DataItem[]
    /** Free "job color" painted by the dispatcher. Null/empty = no color. Unrelated to jobStatus.color. */
    color?: string
    appointmentDate?: string
    appointmentTimeFrom?: string
    appointmentTimeTo?: string
    appointmentDateText?: string
    appointmentFrom?: Date
    appointmentTo?: Date
    appointmentReminder?: boolean
    appointmentReminderTime?: number
    appointmentDateForCalendar?: string
    position?: HereGeocodePosition
    notesCount?: number
    attachmentsCount?: number
    invoicesCount?: number
    estimatesCount?: number
    tasksCount?: number
    sentToTech?: boolean
    sentToTechAt?: Date
    sentPasscode?: number
    secondarySentPasscode?: number
    techAccepted?: boolean
    techAcceptedAt?: Date
    techAcceptedTotalSeconds?: number
    startedAt?: Date
    finishedAt?: Date
    ownerUserId?: string
    ownerUser?: CompactUser
    creatorUserId?: string
    creatorUser?: CompactUser
    lastUpdateUserId?: string
    lastUpdateUser?: CompactUser

    localTime?: number
    payment?: JobPaymentModel
    paymentDetails?: JobPaymentDetails
    isClosed?: boolean
    isCanceled?: boolean
    isInProgress?: boolean
    isAppointment?: boolean
    isArchived?: boolean
    /** Percall sent it while an open job with the same phone, address and job type existed. Not a Flag record. */
    isPerCallDuplicate?: boolean
    /** The JobId of that open job. */
    perCallDuplicateOf?: string
    /** That open job came from a different job source. */
    perCallDuplicateOtherSource?: boolean
    techSetteled?: boolean
    sourceSetteled?: boolean
    hasIssue?: boolean
    issueText?: string
    createdDateSortNumber?: number
    closedDateSortNumber?: number
    lastStatusNote?: string
    lastStatusUser?: CompactUser

    ignoreNotCalledAlert?: boolean
    ignoreNotCalledText?: string

    createdAt?: Date
    modifiedAt?: Date
    lastStatusUpdatedAt?: Date

    /** Client-only, set as the job enters the bank (see withFilterTimes): the dates the board's
     *  date filters compare, as UTC epoch ms. */
    filterTimes?: { appointment?: number, created?: number, modified?: number }

    paid?: boolean

    unseenNotes?: boolean

    usersSeenAttachments?: string[]
    usersSeenTasks?: string[]
    usersSeenCalls?: string[]
    jobCalls?: JobCall[]
    // Calls made for an earlier technician: kept on the job, but not counted as "Called".
    previousTechCallIds?: string[]
}

/** Has the job's current technician called the customer? Calls from before the job changed hands don't count. */
export const techHasCalled = (job?: Job) =>
    (job?.jobCalls ?? []).some(c => c.isCompleted && !(c.callId && job?.previousTechCallIds?.includes(c.callId)));


export interface JobApptReminderItem {
    id?: number
    amount?: number
    date?: string
    type?: number
    action?: number
    done?: boolean
}